import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL } from '@core/injectors';
import { ConnectorItemDTO } from '@core/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonConnectorDataService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string,
  ) {}

  getList(): Observable<ConnectorItemDTO[]> {
    return this.http.get<ConnectorItemDTO[]>(`${this.apiBaseUrl}/api/connectors/`);
  }
}
